import { useState, useEffect } from 'react';
import { db } from '../firebase/config';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';

/**
 * Fetches the last 20 notification events fired for a given child.
 * Written by the Cloud Function via Admin SDK into the
 * `reminderSettings/{childId}/history` subcollection.
 *
 * @param {string|null} childId
 * @returns {{ history: Array<{id, type, title, body, firedAt}>, loading: boolean }}
 */
export function useNotificationHistory(childId) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!childId) { setHistory([]); return; }
    let cancelled = false;
    setLoading(true);

    const q = query(
      collection(db, 'reminderSettings', childId, 'history'),
      orderBy('firedAt', 'desc'),
      limit(20)
    );

    getDocs(q)
      .then((snap) => {
        if (!cancelled) {
          setHistory(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        }
      })
      .catch(() => {
        if (!cancelled) setHistory([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [childId]);

  return { history, loading };
}
